import { Button } from '@ironscales/design-system'

export default Button

export const SIZES = Button.SIZES
export const VARIANTS = Button.VARIANTS
export const POSITIONS = Button.POSITIONS
